/* eslint-disable react/jsx-props-no-spreading */
import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

const { Box, SimpleGrid } = Chakra;

const CustomGrid = ({ children, ...props }) => (
  <Box width="100%" maxWidth="1202px" px={4} mx="auto" {...props}>
    <SimpleGrid columns={5} spacing={12}>
      {children}
    </SimpleGrid>
  </Box>
);

export default CustomGrid;

CustomGrid.propTypes = {
  children: PropTypes.node,
};

CustomGrid.defaultProps = {
  children: null,
};
